/* ─── Root ─── */

.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.root[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

/* ─── Label ─── */

.label {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-family: var(--font-sans);
  font-weight: 600;
  color: var(--md-on-surface-variant);
}

.root[data-invalid] .label {
  color: var(--md-error);
}

/* ─── Textarea ─── */

.textarea {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  min-height: 6rem;
  padding: var(--space-3) var(--space-4);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
  background: var(--md-surface-container-highest);
  border: none;
  border-radius: var(--shape-sm);
  outline: 2px solid transparent;
  resize: vertical;
  transition: outline-color var(--motion-duration-short3)
      var(--motion-easing-standard),
    background var(--motion-duration-short3) var(--motion-easing-standard);
}

.textarea::placeholder {
  color: var(--md-on-surface-variant);
}

.textarea:focus {
  outline-color: var(--md-primary);
  background: var(--md-surface-container);
}

.root[data-invalid] .textarea {
  outline-color: var(--md-error);
}

.root[data-invalid] .textarea:focus {
  outline-color: var(--md-error);
  background: var(--md-surface-container);
}

.root[data-disabled] .textarea {
  cursor: not-allowed;
}

/* ─── Auto-grow ─── */

.autoGrow {
  overflow: hidden;
}

/* ─── Description ─── */

.description {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface-variant);
  margin: 0;
}

/* ─── Error ─── */

.error {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-error);
  margin: 0;
}
